import { getController } from '@/services/service'

const url = 'cistypes'

export const cisTypeService = {
	...getController(url),
}

export default cisTypeService
